import { __read } from "tslib";
import React, { useRef, useEffect, useState } from "react";
import classNames from "classnames";
import { TabItem } from "./TabItem";
import { Button } from "../button";
import { useConfig } from "../_util/config-context";
import { useResizeObserver } from "../_util/use-resize-observer";
export function TabBar(_a) {
    var activeId = _a.activeId, tabs = _a.tabs, _b = _a.onActive, onActive = _b === void 0 ? function () { return null; } : _b, addon = _a.addon, vertical = _a.vertical, maxHeight = _a.maxHeight, tabBarRender = _a.tabBarRender, style = _a.style, activeTabAutoScrollIntoView = _a.activeTabAutoScrollIntoView;
    var classPrefix = useConfig().classPrefix;
    // Scroll 相关
    var scrollAreaRef = useRef(null);
    var tabListRef = useRef(null);
    var buttonRef = useRef(null);
    var activeItemRef = useRef(null);
    var _c = __read(useState(0), 2), offset = _c[0], setOffset = _c[1];
    var _d = __read(useState(false), 2), scrolling = _d[0], setScrolling = _d[1];
    // resize 或 tabs/addon 变化时重置滚动
    var width = useResizeObserver(scrollAreaRef).width;
    useEffect(handleScroll, [tabs, addon, width]);
    useEffect(handleActiveItemIntoView, [activeId]);
    // 设置滚动状态
    function handleScroll() {
        var scrolling = getMaxOffset() > 0;
        setScrolling(scrolling);
        // 无需滚动时重置位置
        if (!scrolling) {
            setOffset(0);
        }
        else {
            handleActiveItemIntoView();
        }
    }
    // 处理滚动至当前选中 TabItem
    function handleActiveItemIntoView() {
        if (!activeTabAutoScrollIntoView) {
            return;
        }
        setTimeout(function () {
            if (!scrollAreaRef.current || !activeItemRef.current) {
                return;
            }
            try {
                var scrollAreaRect = scrollAreaRef.current.getBoundingClientRect();
                var activeItemRect = activeItemRef.current.getBoundingClientRect();
                var _a = __read(vertical
                    ? ["top", "bottom"]
                    : ["left", "right"], 2), startPropertyName = _a[0], endPropertyName = _a[1];
                var buttonProperty = vertical
                    ? buttonRef.current.clientHeight
                    : buttonRef.current.clientWidth;
                var startDelta = scrollAreaRect[startPropertyName] -
                    activeItemRect[startPropertyName] +
                    buttonProperty;
                var endDelta = activeItemRect[endPropertyName] -
                    scrollAreaRect[endPropertyName] +
                    buttonProperty;
                if (startDelta > 0) {
                    setOffset(Math.min(0, offset + startDelta));
                }
                else if (endDelta > 0) {
                    setOffset(Math.max(0 - getMaxOffset(), offset - endDelta));
                }
            }
            catch (_) {
                // ignore
            }
        }, 0);
    }
    // 获取最大滚动偏移
    function getMaxOffset() {
        // 垂直时不指定 maxHeight 不触发滚动
        if (!scrollAreaRef.current || (vertical && !maxHeight)) {
            return 0;
        }
        var propertyName = vertical ? "clientHeight" : "clientWidth";
        var scrollAreaProperty = vertical
            ? maxHeight
            : scrollAreaRef.current[propertyName];
        var tabListProperty = tabListRef.current[propertyName];
        var buttonProperty = buttonRef.current[propertyName];
        if (scrollAreaProperty >= tabListProperty) {
            return 0;
        }
        return tabListProperty - (scrollAreaProperty - buttonProperty * 2);
    }
    // 获取最大单次滚动步长
    function getStep() {
        var propertyName = vertical ? "clientHeight" : "clientWidth";
        return (scrollAreaRef.current[propertyName] - buttonRef.current[propertyName] * 2);
    }
    function handleBackward() {
        setOffset(function (offset) { return Math.min(0, offset + getStep()); });
    }
    function handleForward() {
        setOffset(function (offset) { return Math.max(0 - getMaxOffset(), offset - getStep()); });
    }
    return (React.createElement("div", { className: classPrefix + "-tabs__tabbar", style: style },
        React.createElement("div", { ref: scrollAreaRef, className: classNames(classPrefix + "-tabs__scroll-area", {
                "is-scrolling": scrolling,
            }), style: {
                maxHeight: vertical ? maxHeight : undefined,
            } },
            React.createElement("ul", { ref: tabListRef, className: classPrefix + "-tabs__tablist", style: {
                    transition: "transform ease-out .2s",
                    transform: vertical
                        ? "translate3d(0, " + offset + "px, 0)"
                        : "translate3d(" + offset + "px, 0, 0)",
                } }, tabs.map(function (tab) { return (React.createElement(TabItem, { ref: tab.id === activeId ? activeItemRef : undefined, key: tab.id, label: tab.label, actived: tab.id === activeId, disabled: tab.disabled, onClose: tab.onClose ? function (evt) { return tab.onClose(tab, evt); } : null, onClick: function (evt) { return onActive(tab, evt); }, render: function (children) { return tabBarRender(children, tab); }, className: tab.className, style: tab.style })); })),
            React.createElement(Button, { ref: buttonRef, className: classPrefix + "-tabs__backward", type: "icon", htmlType: "button", icon: vertical ? "arrowup" : "arrowleft", disabled: offset >= 0, onClick: handleBackward }),
            React.createElement(Button, { className: classPrefix + "-tabs__forward", type: "icon", htmlType: "button", icon: vertical ? "arrowdown" : "arrowright", disabled: offset <= 0 - getMaxOffset(), onClick: handleForward })),
        React.createElement("div", { className: classPrefix + "-tabs__addons" }, addon)));
}
TabBar.displayName = "TabBar";
//# sourceMappingURL=TabBar.js.map